import styled from "styled-components";
import IconPeragal from "../../Pages/images/Icon_Cropped.png";
import { Conatainer } from "../../GlobalStyles";

export const Nav = styled.nav`
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid #e4e7ec;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const NavbarContainer = styled(Conatainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const NavLogo = styled.div`
  color: var(--ink);
  font-size: 1.06rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

export const NavIcon = styled.span`
  width: 38px;
  height: 38px;
  background: url(${IconPeragal}) center/contain no-repeat;
`;
